import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setGCSEyeResponseOptions } from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'

export function* getGCSEyeOpeningResponseOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const eyeOpeningResponse: IOptionsResponse = yield call([optionsService, optionsService.getEyeOpeningResponse])
    const { entity } = eyeOpeningResponse
    yield put(setGCSEyeResponseOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getGCSEyeOpeningResponseOptions() error: ${e}`))
  }
}

export function* getGCSEyeOpeningResponseOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getGCSEyeOpeningResponseOptions)
}
